<template>
  <div
    v-for="(item, key) in questionList"
    :key="item.StemId"
    class="question-list"
  >
    <questionItem
      v-if="item.show"
      class="list-box"
      :item="item"
      :keys="key"
      :preview="preview"
    />
  </div>
</template>
<script>
  import questionItem from './questionItem'
  export default {
    name: 'QuestionList',
    components: {
      questionItem,
    },
    props: {
      form: {
        type: Object,
        default: () => {
          return {}
        },
      },
      preview: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      dragOptions() {
        return {
          animation: 600,
          group: 'description',
        }
      },
      questionList() {
        return this.form.questionList
      },
    },
    watch: {
      questionList: {
        handler(val) {
          this.checkAnswer(val)
        },
        deep: true,
      },
    },
    created() {},
    mounted() {
      // console.log('questionList', this.questionList)
    },
    methods: {
      edit(item) {
        item.edit = true
      },
      // 检测是否显示该题
      checkAnswer(list) {
        const answerList = []
        list.forEach((item) => {
          if (item.answer) {
            answerList.push(item.answer)
          }
        })

        list.forEach((item) => {
          if (item.Depend && answerList.includes(item.DependOption)) {
            item.show = true
            return
          }
          if (item.Depend && !answerList.includes(item.DependOption)) {
            item.show = false
          }
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .question-list {
    position: relative;
    margin: 20px 0 30px;
    background: #fff;
    &:hover {
      .tools {
        display: block;
      }
    }
    .tools {
      position: absolute;
      right: 20px;
      top: 10px;
      line-height: 1;
      display: none;
      i {
        font-size: 20px;
        // color: #999;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
</style>
